const input = {
    username: 'ユーザー名',
    password: 'パスワード',
    email: 'メールアドレス',
    phone_number: '電話番号',
    confirm_password: 'パスワード確認',
    search_region_code: '地域コード検索',
    backup_code: 'バックアップコード',
    code: 'コード',
    label_with_optional: '{{label}}（任意）',
    email_address: 'メールアドレス',
    email_placeholder: 'メールアドレスを入力',
    enter_email: 'メールアドレスを入力',
};
export default Object.freeze(input);
